import { render, staticRenderFns } from "./accountTab.vue?vue&type=template&id=64499ab0&scoped=true"
import script from "./accountTab.vue?vue&type=script&lang=js"
export * from "./accountTab.vue?vue&type=script&lang=js"
import style0 from "./accountTab.vue?vue&type=style&index=0&id=64499ab0&prod&lang=scss&scoped=true"
import style1 from "./accountTab.vue?vue&type=style&index=1&id=64499ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64499ab0",
  null
  
)

export default component.exports